import React from 'react'
import { DOCUMENT_TYPE } from '../../../constants/app/document';
import { STATUS_SERVICE } from '../../../constants/app/services';
import classNames from 'classnames';
import Captcha from '../../shared/captcha';

export const LoginBody = ({ form = {}, handleChange, handleSubmit, isRequired = {}, status, onVerifyCaptcha }) => {
	return(
		<div className="Login-body">
			<form>
				<div className="row">
					<div className="col-xs-12 col-md-12 text-center">
						<h1 className="h1--white">Pacífico <small className="text-lg--white">Inspecciones Vehiculares</small></h1>
					</div>
					<div className="col-xs-12 col-md-12">
						<div className={classNames('ui-input-group bg-white', {error: isRequired.document})}>
							<label className="text-md--light text-left"></label>
							<select className="ui-form-control" onChange={handleChange('documentType')}>
								<option disabled="">Tipo de Documento</option>
								{
									Object.keys(DOCUMENT_TYPE).map(key =>
										<option key={key} value={key}>{DOCUMENT_TYPE[key].label}</option>
									)
								}
							</select>
							<span className="ui-input-group-addon-right">
								<span className="icon-nav-down"></span>
							</span>
						</div>
					</div>
					<div className={classNames('col-xs-12 col-md-12 mt5 ui-input-group', {error: isRequired.document})}>
						<input className="ui-form-control " placeholder="Número de documento" onChange={handleChange('username')} value={form.username} />
					</div>
					<div className={classNames('col-xs-12 col-md-12 mt5 ui-input-group', {error: isRequired.password})}>
						<input className="ui-form-control " placeholder="Contraseña"  onChange={handleChange('password')} type="password" value={form.password} />
					</div>
					{(status === STATUS_SERVICE.ERROR) && <div className="text-error text-left">Documento y contraseña deben coincidir</div>}
					<div className="col-xs-12 col-md-12">
						{/* <button 
							type="button"
							className="btn btn-primary w100p mt10"
							disabled={status === STATUS_SERVICE.INPROGRESS || (!form.username || !form.password || !form.documentType || form.documentType === 'Tipo de Documento')}
							onClick={handleSubmit.bind(this, form)}
							>
							{(status === STATUS_SERVICE.INPROGRESS) ? 'Ingresando' : 'Entrar'}
						</button> */}
						 <Captcha
							buttonCss="btn btn-primary w100p mt10"
							disabled={status === STATUS_SERVICE.INPROGRESS || (!form.username || !form.password || !form.documentType || form.documentType === 'Tipo de Documento')}
							label={(status === STATUS_SERVICE.INPROGRESS) ? 'Ingresando' : 'Entrar'}
							size="invisible"
							onVerifyCaptcha={onVerifyCaptcha}
						/>
					</div>
				</div>
			</form>
		</div>
	)
}

export default LoginBody;



// WEBPACK FOOTER //
// ./src/components/app/login/Login.js